import { __ } from '@wordpress/i18n';
import { FIELD_MODES } from './fieldTypes';

export const INITIAL_CARD_SECTIONS = [
  {
    id: 'image-overlay-top-left',
    title: __('Image Overlay Left', 'havenlytics'),
    icon: 'tags',
    mode: FIELD_MODES.PRESET,
    fields: [
      { 
        id: 'tags-overlay', 
        type: 'badge', 
        label: __('Badge', 'havenlytics'), 
        mode: FIELD_MODES.PRESET,
        value: { text: __('Featured', 'havenlytics'), style: 'primary' } 
      }
    ]
  },
  {
    id: 'image-overlay-top-right',
    title: __('Image Overlay Right', 'havenlytics'),
    icon: 'heart',
    mode: FIELD_MODES.PRESET,
    fields: [
      { 
        id: 'favorite-button', 
        type: 'favorite', 
        label: __('Favorite Button', 'havenlytics'), 
        mode: FIELD_MODES.PRESET,
        value: { isFavorite: false } 
      }
    ]
  },
  {
    id: 'thumbnail',
    title: __('Thumbnail', 'havenlytics'),
    icon: 'image',
    mode: FIELD_MODES.PRESET,
    fields: [
      { 
        id: 'thumbnail-image', 
        type: 'image', 
        label: __('Thumbnail Image', 'havenlytics'), 
        mode: FIELD_MODES.PRESET,
        value: { type: 'single', url: '' } 
      }
    ]
  },
  {
    id: 'image-overlay-bottom-left',
    title: __('Image Overlay Bottom Left', 'havenlytics'),
    icon: 'dollar-sign',
    mode: FIELD_MODES.PRESET,
    fields: [
      { 
        id: 'price-button', 
        type: 'price', 
        label: __('Price', 'havenlytics'), 
        mode: FIELD_MODES.PRESET,
        value: { value: '1,250,000', currency: 'USD' } 
      }
    ]
  },
  {
    id: 'image-overlay-bottom-right',
    title: __('Image Overlay Bottom Right', 'havenlytics'),
    icon: 'share-alt',
    mode: FIELD_MODES.PRESET,
    fields: [
      { 
        id: 'share-button', 
        type: 'share', 
        label: __('Share', 'havenlytics'), 
        mode: FIELD_MODES.PRESET,
        value: {} 
      }
    ]
  },
  {
    id: 'avatar',
    title: __('Avatar', 'havenlytics'),
    icon: 'user',
    mode: FIELD_MODES.BOTH,
    fields: [
      { 
        id: 'avatar-image', 
        type: 'avatar', 
        label: __('Avatar', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { type: 'avatar', url: '' } 
      }
    ]
  },
  {
    id: 'card-title',
    title: __('Card Title', 'havenlytics'),
    icon: 'heading',
    mode: FIELD_MODES.BOTH,
    fields: [
      { 
        id: 'title-text', 
        type: 'title', 
        label: __('Property Title', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { text: __('Luxury Villa with Ocean View', 'havenlytics') } 
      },
      { 
        id: 'property-price', 
        type: 'price', 
        label: __('Price', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { value: '1,250,000', currency: 'USD' } 
      },
      { 
        id: 'rating-stars', 
        type: 'rating', 
        label: __('Rating', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { value: 4.5, max: 5 } 
      },
      { 
        id: 'property-location', 
        type: 'location', 
        label: __('Location', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { text: __('123 Ocean View Drive, Malibu, CA', 'havenlytics') } 
      }
    ]
  },
  {
    id: 'card-content',
    title: __('Card Content', 'havenlytics'),
    icon: 'list',
    mode: FIELD_MODES.PRESET,
    fields: [
      { 
        id: 'phone-number', 
        type: 'phone', 
        label: __('Phone', 'havenlytics'), 
        mode: FIELD_MODES.PRESET,
        value: { number: '+1 234 567 8900' } 
      },
      { 
        id: 'email-address', 
        type: 'email', 
        label: __('Email', 'havenlytics'), 
        mode: FIELD_MODES.PRESET,
        value: { address: 'contact@example.com' } 
      },
      { 
        id: 'website-url', 
        type: 'website', 
        label: __('Website', 'havenlytics'), 
        mode: FIELD_MODES.PRESET,
        value: { url: 'www.example.com' } 
      },
      { 
        id: 'posted-time', 
        type: 'datetime', 
        label: __('Date/Time', 'havenlytics'), 
        mode: FIELD_MODES.PRESET,
        value: { text: __('Posted 2 days ago', 'havenlytics') } 
      }
    ]
  },
  {
    id: 'schedule-tour',
    title: __('Schedule Tour', 'havenlytics'),
    icon: 'calendar-alt',
    mode: FIELD_MODES.BOTH,
    fields: [
      { 
        id: 'schedule-tour-button', 
        type: 'button', 
        label: __('Button', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { text: __('Schedule Tour', 'havenlytics'), icon: 'calendar-alt' } 
      }
    ]
  },
  {
    id: 'features',
    title: __('Features', 'havenlytics'),
    icon: 'star',
    mode: FIELD_MODES.BOTH,
    fields: [
      { 
        id: 'feature-beds', 
        type: 'beds', 
        label: __('Beds', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { value: '3' } 
      },
      { 
        id: 'feature-baths', 
        type: 'baths', 
        label: __('Baths', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { value: '2' } 
      },
      { 
        id: 'feature-receptions', 
        type: 'receptions', 
        label: __('Receptions', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { value: '2' } 
      },
      { 
        id: 'feature-sqft', 
        type: 'sqft', 
        label: __('Square Feet', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { value: '2,980' } 
      }
    ]
  },
  {
    id: 'excerpt',
    title: __('Excerpt', 'havenlytics'),
    icon: 'align-left',
    mode: FIELD_MODES.BOTH,
    fields: [
      { 
        id: 'property-excerpt', 
        type: 'excerpt', 
        label: __('Excerpt', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { text: __('Stunning oceanfront villa with panoramic views, modern amenities, and luxurious finishes. Features include infinity pool, home theater, and smart home technology.', 'havenlytics') } 
      }
    ]
  },
  {
    id: 'location',
    title: __('Location', 'havenlytics'),
    icon: 'map-marker-alt',
    mode: FIELD_MODES.BOTH,
    fields: [
      { 
        id: 'property-location', 
        type: 'location', 
        label: __('Location', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { text: __('123 Ocean View Drive, Malibu, CA', 'havenlytics') } 
      }
    ]
  },
  {
    id: 'card-footer-left',
    title: __('Card Footer Left', 'havenlytics'),
    icon: 'folder',
    mode: FIELD_MODES.BOTH,
    fields: [
    { 
        id: 'view-property-button', 
        type: 'view-btn', // Changed from 'button' to 'view-btn'
        label: __('View Property Button', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { 
          text: __('View Property', 'havenlytics'), 
          style: 'primary',
          type: 'view-property'
        } 
      },
      { 
        id: 'property-badge', 
        type: 'badge', 
        label: __('Badge', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { text: __('Featured', 'havenlytics'), style: 'secondary' }  // Changed from "Villa" to "Featured"
      },
      { 
        id: 'property-status', 
        type: 'status', 
        label: __('Status', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { text: __('Active', 'havenlytics'), color: 'green' } 
      },
      { 
        id: 'posted-time', 
        type: 'time', 
        label: __('Time', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { text: __('2 days ago', 'havenlytics') } 
      }
    ]
  },
  {
    id: 'card-footer-right',
    title: __('Card Footer Right', 'havenlytics'),
    icon: 'eye',
    mode: FIELD_MODES.BOTH,
    fields: [
      { 
        id: 'share-button-footer', 
        type: 'share', 
        label: __('Share', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: {} 
      },
      { 
        id: 'favorite-button-footer', 
        type: 'favorite', 
        label: __('Favorite', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { isFavorite: false } 
      },
      { 
        id: 'property-rating-footer', 
        type: 'rating', 
        label: __('Rating', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { value: 4.5, max: 5 } 
      },
      { 
        id: 'view-count', 
        type: 'views', 
        label: __('Views', 'havenlytics'), 
        mode: FIELD_MODES.BOTH,
        value: { count: 245 } 
      }
    ]
  }
];